import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "2px"
    },
});

export default useStyles;